import { createActionGroup, emptyProps, props } from '@ngrx/store'

import {
  ContextItem,
  ConversationOutcomeNodeConfig,
} from '@flowx/designer/modules/ai/common/api/conversation-api.types'

export enum DeveloperContextType {
  BusinessRule = 'business_rule',
  Expression = 'expression',
  ComputedValue = 'computed_value',
  ReusableFunction = 'reusable_function',
}

export type NodeConfigChatPayload = {
  nodeId: string
  nodeName: string
  aiNodeType: string
  workflowId: string
  currentConfig: ConversationOutcomeNodeConfig
}

export const AiCodeEditorContextMenuActions = createActionGroup({
  source: 'AiCodeEditorContextMenu',
  events: {
    improveCodeOptionClick: emptyProps(),
    addCommentOptionClick: emptyProps(),
  },
})

export const AiDeveloperActions = createActionGroup({
  source: 'AiDeveloper',
  events: {
    keepOutcome: emptyProps(),
    keepOutcomeSuccess: emptyProps(),
    discardOutcome: emptyProps(),
    discardOutcomeSuccess: emptyProps(),
    nodeConfigChatOpened: props<NodeConfigChatPayload>(),
    generateSchemaToggled: props<{ enabled: boolean }>(),
    generateBrFromNodeAction: emptyProps(),
    dependencySummaryReceived: props<{
      messageText: string
      contextDataItems: ContextItem[]
    }>(),
  },
})
